/* import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { TreeNode } from 'primeng/api';
import { IdName } from '../domain/idname';
import { IdNameReportType } from '../domain/idnamereporttype';
import { Configuration } from '../domain/configuration';
import { Totaling } from '../domain/totaling';
import { IdNameDescription } from '../domain/idnamedesc';
import { FormulaElement } from '../domain/formulaElement';

@Injectable()
export class LookupService {

    uri = '/api/lookup';

    allReportFormulasPickersIds: number[];

    constructor(private http: HttpClient) {}

    setAllReportFormulasPickersIds(formulae: FormulaElement[]) {
      this.allReportFormulasPickersIds = [];

      formulae.forEach(formula => {
        this.allReportFormulasPickersIds.push(formula.IdLine);
      });
    }

    createTreeFor(ids: string): Promise<TreeNode[]> {
        const companyId = JSON.parse(localStorage.getItem('currentCompany')).id;
        const getUri = `${this.apiUrl}${this.uriPath}/create-tree-for/${ids}`;
        const promise = this.http.get<TreeNode[]>(getUri).toPromise();
        return promise;
    }

    getHierarchy(what : String) : Promise<TreeNode[]> {
        let promise = this.http.get<TreeNode>(`${this.apiUrl}${this.uriPath}/${what}`)
                          .toPromise()
                          .then(data => data.children);
        //promise.then(data => console.log('Parsed to: ' + JSON.stringify(data)));
        return promise;
    }

    getIdName(what : String) : Promise<IdName[]> {
      let promise = this.http.get<IdName[]>(`${this.apiUrl}${this.uriPath}/${what}`)
                        .toPromise();
      //promise.then(data => console.log('Parsed to: ' + JSON.stringify(data)));
      return promise;
    }

    extractTotalings(what : Totaling[]) : Promise<IdName[]> {
        let promise = this.http.get<IdName[]>(`${this.apiUrl}${this.uriPath}/extract-totalings/${what}`)
                          .toPromise();
        //promise.then(data => console.log('Parsed to: ' + JSON.stringify(data)));
        return promise;
      }


    getIdNameReportType(what : String) : Promise<IdNameReportType[]> {
        let promise = this.http.get<IdNameReportType[]>(`${this.apiUrl}${this.uriPath}/${what}`)
                          .toPromise();
        //promise.then(data => console.log('Parsed to: ' + JSON.stringify(data)));
        return promise;
      }

      getLinesForReport(what : number) : Promise<IdName[]> {
        let promise = this.http.get<IdName[]>(`${this.apiUrl}${this.uriPath}/formula-report-lines/${what}`)
                          .toPromise();
        // promise.then(data => console.log('Parsed to: ' + JSON.stringify(data)));
        return promise;
      }

      getDimensionValues(dimension : number) : Promise<TreeNode[]> {
        return this.getHierarchy(`dimensionvalues/${dimension}`);
      }

      getDimensionValuesFlat(dimension : number) : Promise<TreeNode[]> {
        return this.getHierarchy(`dimensionvaluesflat/${dimension}`);
      }
}
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TreeNode } from 'primeng/api';
import { IdName } from '../domain/idname';
import { IdNameReportType } from '../domain/idnamereporttype';
import { Configuration } from '../domain/configuration';
import { Totaling } from '../domain/totaling';
import { IdNameDescription } from '../domain/idnamedesc';
import { FormulaElement } from '../domain/formulaElement';
import { Observable } from 'rxjs';
import { switchMap, tap, catchError } from 'rxjs/operators';
import { DynamicBackendConfigService } from './dynamic-backend-config.service';
import { AppConfigService } from './app-config.service';

@Injectable()
export class LookupService {

    private uriPath = '/api/lookup';
    uri = '';
    apiUrl="";
    
    allReportFormulasPickersIds: number[];

    constructor(private http: HttpClient,
         private dynamicConfig: DynamicBackendConfigService,
         private appConfigService: AppConfigService
         ) {
        this.apiUrl = this.appConfigService.apiUrl;
        /*this.dynamicConfig.getApiUrl().subscribe(apiUrl => {
            this.uri = this.dynamicConfig.extractSecondURL(apiUrl ? `${apiUrl}${this.uriPath}` : this.uriPath);
          });
          */
    }
/* 
    setAllReportFormulasPickersIds(formulae: FormulaElement[]) {
        this.allReportFormulasPickersIds = [];

        formulae.forEach(formula => {
            this.allReportFormulasPickersIds.push(formula.IdLine);
        });
    }

    createTreeFor(ids: string): Observable<TreeNode[]> {
        const companyId = JSON.parse(localStorage.getItem('currentCompany')).id;
        const getUri = `${this.apiUrl}${this.uriPath}/create-tree-for/${ids}`;
        return this.http.get<TreeNode[]>(getUri);
    }

    getHierarchy(what: string): Observable<any> {
        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriPath}/${what}`;
                return this.http.get<TreeNode>(url).pipe(
                    tap(data => data.children),
                    catchError(error => {
                        console.log('Error:', error);
                        throw error;
                    })
                );
            })
        );
    }

    getIdName(what: string): Observable<IdName[]> {
        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriPath}/${what}`;
                return this.http.get<IdName[]>(url);
            })
        );
    }

    extractTotalings(what: Totaling[]): Observable<IdName[]> {
        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriPath}/extract-totalings/${what}`;
                return this.http.get<IdName[]>(url);
            })
        );
    }

    getIdNameReportType(what: string): Observable<IdNameReportType[]> {
        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriPath}/${what}`;
                return this.http.get<IdNameReportType[]>(url);
            })
        );
    }

    getLinesForReport(what: number): Observable<IdName[]> {
        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriPath}/formula-report-lines/${what}`;
                return this.http.get<IdName[]>(url);
            })
        );
    }

    getDimensionValues(dimension: number): Observable<TreeNode[]> {
        return this.getHierarchy(`dimensionvalues/${dimension}`);
    }

    getDimensionValuesFlat(dimension: number): Observable<TreeNode[]> {
        return this.getHierarchy(`dimensionvaluesflat/${dimension}`);
    } */
    setAllReportFormulasPickersIds(formulae: FormulaElement[]) {
        this.allReportFormulasPickersIds = [];
  
        formulae.forEach(formula => {
          this.allReportFormulasPickersIds.push(formula.IdLine);
        });
      }
  
      createTreeFor(ids: string): Promise<TreeNode[]> {
          const companyId = JSON.parse(localStorage.getItem('currentCompany')).id;
          const getUri = `${this.apiUrl}${this.uriPath}/create-tree-for/${ids}`;
          const promise = this.http.get<TreeNode[]>(getUri).toPromise();
          return promise;
      }

      createTreeForList(ids: string): Promise<TreeNode[]> {
        const getUri = `${this.apiUrl}${this.uriPath}/create-tree-for-list`;
        const requestBody = { ids: ids };
        const promise = this.http
            .post<TreeNode[]>(getUri, requestBody, { headers: { "Content-Type": "application/json" } })
            .toPromise();
    
        return promise;
    }
    
  
      getHierarchy(what : String) : Promise<TreeNode[]> {
          let promise = this.http.get<TreeNode>(`${this.apiUrl}${this.uriPath}/${what}`)
                            .toPromise()
                            .then(data => data.children);
          //promise.then(data => console.log('Parsed to: ' + JSON.stringify(data)));
          return promise;
      }
  
      getIdName(what : String) : Promise<IdName[]> {
        let promise = this.http.get<IdName[]>(`${this.apiUrl}${this.uriPath}/${what}`)
                          .toPromise();
        //promise.then(data => console.log('Parsed to: ' + JSON.stringify(data)));
        return promise;
      }
  
      extractTotalings(what : Totaling[]) : Promise<IdName[]> {
          let promise = this.http.get<IdName[]>(`${this.apiUrl}${this.uriPath}/extract-totalings/${what}`)
                            .toPromise();
          //promise.then(data => console.log('Parsed to: ' + JSON.stringify(data)));
          return promise;
        }
  
  
      getIdNameReportType(what : String) : Promise<IdNameReportType[]> {
          let promise = this.http.get<IdNameReportType[]>(`${this.apiUrl}${this.uriPath}/${what}`)
                            .toPromise();
          //promise.then(data => console.log('Parsed to: ' + JSON.stringify(data)));
          return promise;
        }
  
        getLinesForReport(what : number) : Promise<IdName[]> {
          let promise = this.http.get<IdName[]>(`${this.apiUrl}${this.uriPath}/formula-report-lines/${what}`)
                            .toPromise();
          // promise.then(data => console.log('Parsed to: ' + JSON.stringify(data)));
          return promise;
        }
  
        getDimensionValues(dimension : number) : Promise<TreeNode[]> {
          return this.getHierarchy(`dimensionvalues/${dimension}`);
        }

        getDimensionValuesList(dimension : number) : Promise<IdName[]> {
            let promise = this.http.get<IdName[]>(`${this.apiUrl}${this.uriPath}/dimensionvalueslist/${dimension}`)
                            .toPromise();
          return promise;
          }
  
        getDimensionValuesFlat(dimension : number) : Promise<TreeNode[]> {
          return this.getHierarchy(`dimensionvaluesflat/${dimension}`);
        }
}
